import { useTranslation } from 'react-i18next';

export function useFaceErrorFn() {
  const [t] = useTranslation(['common', 'face']);
  return (e?: any, defaultFallback = undefined) => {
    const errKey = typeof e === 'object' ? e?.error_code : e;
    const result = t(`face:errors.by-key.${errKey}`, {
      defaultValue:  defaultFallback ?? t('common:labels.unknown-err')
    });
    return result;
  };
}

export default useFaceErrorFn;
